// import { extend } from 'lodash';

// export type Guid = string;

export class Entities {
    static lookups: any;
}
